// client-side CSV export of what the VSM table currently shows: the visible
// columns (action/pseudo columns dropped) over the filtered rows
const SKIP_KEYS = ['details', 'update_status', 'actuals_chart', 'delete', 'reprocess', 'retry']

function csvEscape(value) {
  if (value == null) return ''
  const s = Array.isArray(value) ? value.join('; ') : String(value)
  return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
}

export function downloadVsmCsv(fields, items, filename) {
  const cols = (fields || []).filter(f => f && f.key && !SKIP_KEYS.includes(f.key))
  const lines = [cols.map(c => csvEscape(c.label || c.key)).join(',')]
  for (const item of items || []) {
    lines.push(cols.map(c => csvEscape(item[c.key])).join(','))
  }
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
